"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.densities = void 0;

var _stylitas = require("@creditas/stylitas");

var _consts = require("./consts");

// TODO: replace with Design System spacing/density Tokens
const X_PADDING = 16;
const FOCUSED_X_PADDING = X_PADDING - _consts.FOCUSED_BORDER_DELTA;
const DEFAULT_Y_PADDING = 16;
const COMFORTABLE_Y_PADDING = 8;
const COMPACT_Y_PADDING = 4;
const DEFAULT_HEIGHT = 80;
const COMFORTABLE_HEIGHT = DEFAULT_HEIGHT - (DEFAULT_Y_PADDING - COMFORTABLE_Y_PADDING) * 2;
const COMPACT_HEIGHT = COMFORTABLE_HEIGHT - (COMFORTABLE_Y_PADDING - COMPACT_Y_PADDING) * 2;

const densities = ({
  size,
  readOnly,
  height
}) => {
  switch (size) {
    case 'default':
      return (0, _stylitas.css)`
        height: ${height != null ? height : DEFAULT_HEIGHT}px;
        padding: ${DEFAULT_Y_PADDING}px ${X_PADDING}px;
        min-height: ${DEFAULT_HEIGHT}px;

        ${!readOnly && `:focus-within {
              padding: ${DEFAULT_Y_PADDING - _consts.FOCUSED_BORDER_DELTA}px
              ${FOCUSED_X_PADDING}px;
            }`}
      `;

    case 'comfortable':
      return (0, _stylitas.css)`
        height: ${height != null ? height : COMFORTABLE_HEIGHT}px;
        padding: ${COMFORTABLE_Y_PADDING}px ${X_PADDING}px;
        min-height: ${COMFORTABLE_HEIGHT}px;

        ${!readOnly && `:focus-within {
              padding: ${COMFORTABLE_Y_PADDING - _consts.FOCUSED_BORDER_DELTA}px
                ${FOCUSED_X_PADDING}px;
            }`}
      `;

    case 'compact':
      return (0, _stylitas.css)`
        height: ${height != null ? height : COMPACT_HEIGHT}px;
        padding: ${COMPACT_Y_PADDING}px ${X_PADDING}px;
        min-height: ${COMPACT_HEIGHT}px;

        ${!readOnly && `:focus-within {
              padding: ${COMPACT_Y_PADDING - _consts.FOCUSED_BORDER_DELTA}px
                ${FOCUSED_X_PADDING}px;
            }`}
      `;

    default:
      return (0, _stylitas.css)``;
  }
};

exports.densities = densities;